import { render, staticRenderFns } from "./DialogPatFiles.vue?vue&type=template&id=abc80ef6&scoped=true"
import script from "./DialogPatFiles.vue?vue&type=script&lang=js"
export * from "./DialogPatFiles.vue?vue&type=script&lang=js"
import style0 from "./DialogPatFiles.vue?vue&type=style&index=0&id=abc80ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc80ef6",
  null
  
)

export default component.exports